import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class PayrollSummaryListItem extends SearchModelBase {
    refNo: string = '';
    payrollDate: string | null = null;
    fromPayrollDate: string | null = null;
    toPayrollDate: string | null = null;
    branch: string = '';
    grossAmt: number|null = null;
    fromGrossAmt: number|null = null;
    toGrossAmt: number|null = null;
    payableFedTax: number|null = null;
    fromPayableFedTax: number|null = null;
    toPayableFedTax: number|null = null;
    paidAmtFedTax: number|null = null;
    fromPaidAmtFedTax: number|null = null;
    toPaidAmtFedTax: number|null = null;
    payableStateTax: number|null = null;
    fromPayableStateTax: number|null = null;
    toPayableStateTax: number|null = null;
    paidAmtStateTax: number|null = null;
    fromPaidAmtStateTax: number|null = null;
    toPaidAmtStateTax: number|null = null;
    payableNetSalary: number|null = null;
    fromPayableNetSalary: number|null = null;
    toPayableNetSalary: number|null = null;
    paidAmtNetSalary: number|null = null;
    fromPaidAmtNetSalary: number|null = null;
    toPaidAmtNetSalary: number|null = null;
    addTaxAmt: number|null = null;
    fromAddTaxAmt: number|null = null;
    toAddTaxAmt: number|null = null;
    addTaxPaidAmt: number|null = null;
    fromAddTaxPaidAmt: number|null = null;
    toAddTaxPaidAmt: number|null = null;
    addPayAmt: number|null = null;
    fromAddPayAmt: number|null = null;
    toAddPayAmt: number|null = null;
    addPayPaidAmt: number|null = null;
    fromAddPayPaidAmt: number|null = null;
    toAddPayPaidAmt: number|null = null;
    remark: string = '';
    void: boolean = false;
    voidInputDate: string | null = null;
    fromVoidInputDate: string | null = null;
    toVoidInputDate: string | null = null;
    createdBy: string = '';
    modifiedAt: string | null = null;
    fromModifiedAt: string | null = null;
    toModifiedAt: string | null = null;
    modifiedBy: string = '';
    blank: string = '';
    id: number = 0;

    //cloud only
    fedTaxPaid: boolean = false;
    stateTaxPaid: boolean = false;
    netSalaryPaid: boolean = false;
    addTaxPaid: boolean = false;
    addPayPaid: boolean = false; 

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Date', width: 75, dataIndex: 'payrollDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 2, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus: true }),
        XCol.Create({ col: 3, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Gross Salary', width: 100, dataIndex: 'grossAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 5, text: 'Payroll Tax (Fed)', width: 100, dataIndex: 'payableFedTax', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Paid', width: 40, dataIndex: 'fedTaxPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 7, text: 'Payroll Tax(State)', width: 100, dataIndex: 'payableStateTax', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Paid', width: 40, dataIndex: 'stateTaxPaid', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 9, text: 'Net Salary', width: 100, dataIndex: 'payableNetSalary', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'Paid', width: 40, dataIndex: 'netSalaryPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 11, text: 'Additional Tax', width: 100, dataIndex: 'addTaxAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Paid', width: 40, dataIndex: 'addTaxPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 13, text: 'Salary Deduction', width: 100, dataIndex: 'addPayAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 14, text: 'Paid', width: 40, dataIndex: 'addPayPaid',  type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        // XCol.Create({ col: 15, text: 'Void', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false}),
        // XCol.Create({ col: 16, text: 'Void Date', width: 75, dataIndex: 'voidInputDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 17, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 18, text: 'Update', width: 100, dataIndex: 'modifiedAt', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 19, text: 'Update by', width: 80, dataIndex: 'modifiedBy'}),
        XCol.Create({ col: 20, text: 'Create By', width: 80, dataIndex: 'createdBy'})
        ];

    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: PayrollSummaryListItem.prototype.id, orderByAscending: false };

    public static formatData(data: PayrollSummaryListItem[]) {
        return data.map((d: PayrollSummaryListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        payrollDate: {from: 'fromPayrollDate', to: 'toPayrollDate'},
        voidInputDate: {from: 'fromVoidInputDate', to: 'toVoidInputDate'},
        modifiedAt: {from: 'fromModifiedAt', to: 'toModifiedAt'},
        grossAmt: {from: 'fromGrossAmt', to: 'toGrossAmt'},
        paidAmtStateTax: {from: 'fromPaidAmtStateTax', to: 'toPaidAmtStateTax'},
        payableFedTax: {from: 'fromPayableFedTax', to: 'toPayableFedTax'},
        paidAmtFedTax: {from: 'fromPaidAmtFedTax', to: 'toPaidAmtFedTax'},
        payableStateTax: {from: 'fromPayableStateTax', to: 'toPayableStateTax'},
        payableNetSalary: {from: 'fromPayableNetSalary', to: 'toPayableNetSalary'},
        paidAmtNetSalary: {from: 'fromPaidAmtNetSalary', to: 'toPaidAmtNetSalary'},
        addTaxAmt: {from: 'fromAddTaxAmt', to: 'toAddTaxAmt'},
        addTaxPaidAmt: {from: 'fromAddTaxPaidAmt', to: 'toAddTaxPaidAmt'},
        addPayAmt: {from: 'fromAddPayAmt', to: 'toAddPayAmt'},
        addPayPaidAmt: {from: 'fromAddPayPaidAmt', to: 'toAddPayPaidAmt'},
    }
}
